import React from 'react'
import { CustomerInlineInput } from './CustomerInlineInput'
import { AddressInlineInput } from '@ztechapps/webui.location'

const addressDocumentFragment = `address {
       street1
       street2
       city
       state
       zip
       fullAddress
       country
    }`

const addressUpdateParams = ({ _id, updatedValue }) => {
  const input = {
    _id,
    'address.street1': updatedValue?.street1,
    'address.street2': updatedValue?.street2,
    'address.city': updatedValue?.city,
    'address.state': updatedValue?.state,
    'address.zip': updatedValue?.zip,
    'address.fullAddress': updatedValue?.fullAddress,
    'address.country': updatedValue?.country,
  }

  return {
    input,
  }
}

export const AddressEdit = ({ initialValues, ...rest }) => (
  <CustomerInlineInput
    parentInputComponent={AddressInlineInput}
    name="address"
    query={addressDocumentFragment}
    initialValues={initialValues}
    displayContent={(e) => e?.fullAddress}
    emptyContent={<div className="text-warning">No address specified, click here to edit </div>}
    updateParams={addressUpdateParams}
    {...rest}
  />
)
